import { FunctionComponent } from "react";

import {
  ButtonsGroupChoiceField,
  Heading,
  MessageBar,
  Stack,
  SubmissionForm,
  SubmissionFormButtons,
  UseFormMethods
} from "@bps/fluent-ui";
import { RestrictionType } from "@libs/api/gateways/plt/plt-gateway.dtos";
import { useRestrictionTypesRefData } from "@libs/api/gateways/plt/plt-gateway.hooks";

import { TENANT_AUTH_HINT } from "../../user/components/auth/user-auth-form.types";

export interface GlobalNetworkRestrictionsValues {
  isUser?: boolean;
  tenantRestrictionType?: RestrictionType;
  restrictionType?: RestrictionType;
}

interface GlobalNetworkRestrictionsSectionProps {
  hasWritePermission: boolean;
  onSubmit: (
    values: GlobalNetworkRestrictionsValues,
    actions: Pick<
      UseFormMethods<GlobalNetworkRestrictionsValues>,
      "reset" | "setValue"
    >
  ) => Promise<void>;
  initialValues: GlobalNetworkRestrictionsValues;
}

export const GlobalNetworkRestrictionsSection: FunctionComponent<GlobalNetworkRestrictionsSectionProps> = ({
  hasWritePermission,
  onSubmit,
  initialValues
}) => {
  const { data: restrictionTypesRefData } = useRestrictionTypesRefData();

  let restrictionOptions =
    restrictionTypesRefData?.map(refData => {
      return { key: refData.code, text: refData.text };
    }) ?? [];

  if (initialValues.isUser) {
    restrictionOptions = [
      { key: RestrictionType.Default, text: "Default" },
      ...restrictionOptions
    ];
  }

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <Heading variant="section-heading">Network Access Restrictions</Heading>
      <SubmissionForm<GlobalNetworkRestrictionsValues>
        initialValues={initialValues}
        hideButtons
        onSubmit={onSubmit}
        disabled={!hasWritePermission}
      >
        {() => {
          return (
            <Stack horizontal horizontalAlign="space-between">
              <Stack>
                <ButtonsGroupChoiceField<string>
                  name="restrictionType"
                  options={restrictionOptions}
                  notUnselectable={true}
                  hint={
                    initialValues.isUser ? (
                      <MessageBar>{`${TENANT_AUTH_HINT} ${
                        restrictionOptions.find(
                          x => x.key === initialValues.tenantRestrictionType
                        )?.text
                      }`}</MessageBar>
                    ) : (
                      undefined
                    )
                  }
                />
              </Stack>
              <SubmissionFormButtons
                classNames={{}}
                hideCancelButton
                submitButtonProps={{ iconProps: { iconName: "Save" } }}
              />
            </Stack>
          );
        }}
      </SubmissionForm>
    </Stack>
  );
};
